import React from "react";
import { Input, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  update_filter_fav,
  update_filter_topic,
  update_filter_solved,
  update_search_string,
} from "../../actions/questionActions";

const solved_options = [
  {
    key: "Solved",
    text: "Solved",
    value: true,
  },
  {
    key: "Unsolved",
    text: "Unsolved",
    value: false,
  },
  {
    key: "All",
    text: "All",
    value: "All",
  },
];

const all_topics = [
  "All",
  "Array",
  "Matrix",
  "LinkedList",
  "String",
  "Searching & Sorting",
  "Binary Trees",
  "Binary Search Trees",
  "Greedy",
  "BackTracking",
  "Stacks & Queues",
  "Heap",
  "Graph",
  "Trie",
  "Dynamic Programming",
  "Bit Manipulation",
  "Favourites",
];

const topic_options = all_topics.map((topic) => ({
  key: topic,
  text: topic,
  value: topic,
}));

const TableOptions = (props) => {
  return (
    <div className="flex">
      <Input
        onChange={(e) => {
          props.update_search_string(e.target.value);
        }}
        style={{ width: "40%" }}
        placeholder="Search"
        icon="search"
        value={props.searchString}
      />
      <span className="ml-5">
        <span className="dropdown-label mr-4">Status</span>
        <Dropdown
          onChange={(e, { value }) => props.update_filter_solved(value)}
          selection
          value={props.solved}
          options={solved_options}
        />
      </span>
      <span className="ml-5">
        <span className="dropdown-label mr-4">Topic</span>
        <Dropdown
          onChange={(e, { value }) => props.update_filter_topic(value)}
          selection
          value={props.topic}
          options={topic_options}
        />
      </span>
    </div>
  );
};

const mapStateToProps = (store) => {
  return {
    topic: store.questions.topic,
    favourites: store.questions.favourites,
    solved: store.questions.solved,
    searchString: store.questions.searchString,
  };
};

export default connect(mapStateToProps, {
  update_filter_fav,
  update_filter_solved,
  update_filter_topic,
  update_search_string,
})(TableOptions);
